/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/indent-decrease-rec";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "IndentDecreaseRec";
export { I as IndentDecreaseRec };
